window.ptTeaser = () => {
    return {
        i18n: {
            withTest: {
                title: null,
                button: {
                    short: null,
                    normal: null
                }
            },
            withoutTest: {
                title: null,
                button: {
                    short: null,
                    normal: null
                }
            }
        },

        title: {
            ['x-text']() {
                if (this.$store.pt.completed) {
                    return this.i18n.withTest.title;
                }
                return this.i18n.withoutTest.title;
            }
        },

        button: {
            ['x-html']() {
                if (this.$store.pt.completed) {
                    return `<span class="lg:hidden">${this.i18n.withTest.button.short}</span><span class="hidden lg:inline">${this.i18n.withTest.button.normal}</span>`;
                }
                return `<span class="lg:hidden">${this.i18n.withoutTest.button.short}</span><span class="hidden lg:inline">${this.i18n.withoutTest.button.normal}</span>`;
            },
            ['@click']() {
                const modal = document.querySelector("[data-pt-modal]");
                if (modal && modal.__x) {
                    modal.__x.$data.open();
                }
            }
        },

        color(identifier) {
            return {
                [':class']() {
                    if (this.$store.pt.completed && !this.$store.pt.has(identifier)) {
                        return "opacity-20";
                    }
                }
            }
        }
    };
};
